import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";

import { db } from "../firebase";
import PipCharacter from "../components/Pip/PipCharacter";
import { fetchPipMasters } from "../services/pipService";

export default function PipMasters() {
  const [data, setData] = useState({ currentMaster: null, allMasters: [] });
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    fetchPipMasters().then(setData);
  }, []);

  useEffect(() => {
    if (!data.currentMaster) return;
    getDoc(doc(db, "users", data.currentMaster)).then((snap) => {
      if (snap.exists()) setCurrentUser({ uid: snap.id, ...snap.data() });
    });
  }, [data.currentMaster]);

  const masters = data.allMasters || [];

  return (
    <div className="pip-masters-page">
      <h1 className="pip-masters-title">Pip <em>Masters</em></h1>
      <p style={{ color: "var(--text-muted)", marginBottom: 8 }}>
        Find Pip in all 60 hiding spots to claim the crown.
      </p>

      {currentUser && (
        <div className="pip-masters-current">
          <PipCharacter size={80} state="found" outfit={{ hat: "challenge_allcategories", shirt: "challenge_100finds" }} />
          <div style={{ marginTop: 12, fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic", fontSize: 24 }}>
            Current Pip Master
          </div>
          <div style={{ fontSize: 18, fontWeight: 700, marginTop: 4 }}>
            @{currentUser.handle || currentUser.username || "master"}
          </div>
          <Link to={`/fan/${currentUser.uid}`} style={{ color: "#e8b86a", fontSize: 13, marginTop: 8, display: "inline-block" }}>
            View profile →
          </Link>
        </div>
      )}

      <div className="pip-masters-list">
        {masters.length === 0 ? (
          <p style={{ color: "var(--text-muted)" }}>No Pip Masters yet — be the first!</p>
        ) : (
          masters.map((m) => (
            <div key={`${m.userId}-${m.achievedAt?.seconds || m.achievedAt}`} className="pip-masters-row">
              <PipCharacter size={36} state="idle" />
              <div style={{ flex: 1 }}>
                <strong>@{m.username || m.userId}</strong>
                <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
                  {m.reignEndedAt ? "Former Pip Master" : "Reigning Master"}
                </div>
              </div>
              <Link to={`/fan/${m.userId}`} style={{ fontSize: 12, color: "#c4790a" }}>Profile</Link>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
